import PaymentList from "@/controllers/payment/payment-list.js";
import CONFIG from "@/assets/js/config.custom.js";
import axios from "axios";
import { canManagePayment } from "@/services/PaymentAccessService";
import "flatpickr/dist/plugins/monthSelect/style.css"
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index.js";

export default {
  extends: PaymentList,

  data() {
    return {
      periodArr: [], 
      search_period_id: null, 
      classArr: [],
      CONFIG,
      dueDateConfig: {
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: "Y-m",
            altFormat: "Y-m",
            theme: "light"
          })
        ]
      },
    };
  },

  computed: {
    paymentOptions() {
      return Object.entries(CONFIG.PARENT_PAYMENT_STATUS_TEXT).map(([id, text]) => ({
        id: Number(id),
        text,
      }));
    },
    paymentHistoryOptions() {
      return CONFIG.PAYMENT_STATUSES_OPTIONS.filter(opt =>[
          CONFIG.PAYMENT_STATUS.STATUS_APPROVED, 
          CONFIG.PAYMENT_STATUS.STATUS_PARENT_ENROLL_REQUEST,
          CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST,
        ].includes(opt.id)
      );
    }
  },

  methods: {
    getStatusClass(status) {
      switch (Number(status)) {
        case CONFIG.PARENT_PAYMENT_STATUS.NOT_PAID:
          return 'bg-light';
        case CONFIG.PARENT_PAYMENT_STATUS.PARTIAL_PAID:
          return 'bg-warning';
        case CONFIG.PARENT_PAYMENT_STATUS.FULLY_PAID:
          return 'bg-success';
        default:
          return 'bg-light';
      }
    },

    getPeriods() {
      this.isLoading = true;
      axios.get('period/periodList')
        .then(res => {
          let defaultOption = [{ id: '0', text: 'Select Academic Year' }];
          this.periodArr = defaultOption.concat(res.data.data);
          
          this.isLoading = false;
        })
        .catch(error => this.handleError(error));
    },

    getClass(yearId) {
      this.searchData.class_id = ''; 
      this.classArr = [];

      axios.get("class/classList/" + yearId, {
        params: {
          campus_id: this.$store.state.user.campus_id,
        }
      })
      .then(res => {
        this.classArr = [{ id: '0', text: 'Select Class' }].concat(res.data);
        this.isLoading = false;
      }).catch(err => this.handleError(err))
    },

    handleError(error) {
      if (error.response && error.response.status == 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      }
      this.isLoading = false;
    },

    reset() {
      this.search_period_id = '0';
      this.termArr = []; 
      this.classArr = [];
      this.searchData = [];
      this.isLoading = true;
      this.getPayment();
      this.isSearched = false;
    },

    searching(page = 1) {
      this.search_status = true;
      this.clearValidationErrors();
      this.isSearch = 1;
      this.isLoading = true;
      if (this.searchData.p_method == 0) {
        this.searchData.p_method = undefined;
      }

      const params = {
        stuName: this.searchData.stuName,
        guardian1Name: this.searchData.guardian1Name,
        item_id: this.searchData.item_id,
        p_method: this.searchData.p_method,
        startDate: this.searchData.startDate,
        endDate: this.searchData.endDate,
        invoiceNumber: this.searchData.invoiceNumber,
        status: this.searchData.status,
        history_status: this.searchData.history_status,
        dueDate: this.searchData.dueDate,
        campus_id: this.campusId,
        search: true,
        acaYear: this.search_period_id,
        classId: this.searchData.class_id, 
      };

      this.searchedData = {
        ...params,
        is_search: 1,
        currentYear: this.currentYearId,
      };

      this.isSearched = true;

      axios.get('payment/search?page=' + page, { params })
        .then((res) => {
          if (res.data) {
            this.paymentData = res.data;
            this.totalRequestedAmount = this.paymentData.data.totalRequestedAmount;
            this.totalReceivedAmount = this.paymentData.data.totalReceivedAmount;
          }
        })
        .catch(error => {
          this.printValidationError(error.response);
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    showDetail(studentPaymentId, tuitionPaymentId) {
      if (tuitionPaymentId === null || tuitionPaymentId === undefined || tuitionPaymentId === '') {
        // redirect to payment detail page
        this.$router.push({ 
          name: 'paymentDetail', 
          params: { invoiceId: studentPaymentId } 
        });
      } else {
        // redirect to tuition payment detail page
        this.$router.push({ 
          name: 'tuitionPaymentDetail', 
          params: { 
            tuitionPaymentId: tuitionPaymentId, 
            studentPaymentId: studentPaymentId 
          },
          query: { from: 'payment-list' }
        });
      }
    },

    showEdit(studentPaymentId, tuitionPaymentId) {
      if (tuitionPaymentId === null || tuitionPaymentId === undefined || tuitionPaymentId === '') {
        this.$router.push({
          name: 'paymentEdit',
          params: { invoiceId: studentPaymentId }
        });
      } else {
        this.$router.push({
          name: 'tuitionPaymentEdit',
          params: {
            tuitionPaymentId: tuitionPaymentId,
            studentPaymentId: studentPaymentId
          },
          query: { from: 'payment-list' }
        });
      }
    },

    /**
    * Common payment action permission checker (includes fully paid + role restriction logic)
    * @param {string} action - edit/delete
    * @param {number} paymentHistoryStatus - status from payment history table
    * @param {number} historyStatus - status from payment table (payment_history_status column)
    * @returns {boolean}
    */
    canManagePayment(action, historyStatus) {
      return canManagePayment(action, historyStatus, this.$store.state.user);
    },

    calculateRemainAmt(total, paid) {
      const totalAmt = String(total).replaceAll(',', '');
      const paidAmt = String(paid).replaceAll(',', '');
      const currency = totalAmt.split(' ')[1];

      return parseFloat(totalAmt) - parseFloat(paidAmt) + " " + currency;
    },

    /**
    * Check if the payment is the first payment (period contains #1)
    * @param {object} payment - payment object
    * @returns {boolean}
    */
    isFirstPayment(payment) {
      if (!payment || payment.tuition_payment_id === undefined || payment.tuition_payment_id === null || payment.tuition_payment_id === '') {
        return false;
      }
      if (!payment.period || typeof payment.period !== 'string') {
        return false;
      }
      if (!payment.period.includes('#')) {
        return false;
      }
      const num = parseInt(payment.period.split('#').pop(), 10);
      return num === 1;
    },

    /**
    * Check if edit button should be shown for a payment
    * @param {object} payment - payment object
    * @returns {boolean}
    */
    canEditPayment(payment) {
      // Permission + fully paid + role restriction check
      if (!this.canManagePayment('edit', payment.payment_history_status)) {
        return false;
      }
      // Regular payment (no tuition, no ferry): show edit if not APPROVED
      if (!payment.tuition_payment_id && !payment.has_ferry_fee) {
        return payment.payment_history_status !== CONFIG.PAYMENT_HISTORY_STATUS_VAL.APPROVED;
      }
      // Ferry fee: show edit only if late fee item also exists
      if (payment.has_ferry_fee) {
        return !!payment.has_late_fee;
      }
      // Tuition payment: show edit if first payment OR has late fee
      return this.isFirstPayment(payment) || !!payment.has_late_fee;
    },
  },

  mounted() {
    this.isLoading = true;
    this.getPeriods();
    this.getThisAcademicYear();
    this.getPaymentMethod();
    this.getItem();

    const queryItemId = this.$route.query.item_id;
    if (queryItemId) {
      this.searchData.item_id = Number(queryItemId) || queryItemId;
      this.searching();
    } else {
      this.getPayment();
    }
  }
};
